import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpInterceptor, HttpErrorResponse, HttpEvent } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { COOKIE } from '@app-lib';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';

import { JwtHelperService } from '@app-lib';
import { HotToastService } from '@ngneat/hot-toast';
import { IApiErrorReturnHeaders } from './jwt-interceptor-model';

// versione semplificata non deve autenticarsi legge solo il cookie ATE.jwt
@Injectable()
export class MainInterceptor implements HttpInterceptor {
  private accessToken: string;
  constructor(
    public _cookie: CookieService,
    private _toast: HotToastService,
    private _router: Router,
    private jwtHelper: JwtHelperService
  ) {}
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.accessToken = this._cookie.get(COOKIE.SYS_JWT);
    if (!this.accessToken) {
      //onsole.log('NG.INT.TOK.ER.01 error: MainInterceptor  no token');
      const lic = sessionStorage.getItem('lic');
      if (!lic) {
        this._router.navigate(['/auth/login']);
      } else {
        this._router.navigate(['/auth/init-licenza/' + lic]);
      }

      //     this._router.navigate(['/' + ERR_PAGE_PATH, 'login', 'NG_INTERC-JWT']);
    } else {
      if (this.jwtHelper.tokenExpired(this.accessToken)) {
        this._toast.error('NG.INT.TOK.EXP.00 error: token is expired', {
          dismissible: true,
          duration: 5000,
          className: 'hot-toastx',
        });
        this._cookie.delete(COOKIE.SYS_JWT);
        this._router.navigate(['/auth/login']);

        return;
      }

      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.accessToken}`,
        },
      });
    }

    // samesite , 'Set-Cookie': 'HttpOnly;Secure;SameSite=Strict'

    const authReq = request.clone({ headers: request.headers });
    return next.handle(authReq).pipe(
      catchError((err: Observable<any>) => {
        if (err instanceof HttpErrorResponse) {
          return this.handleErrors(err);
        } else {
          return of(this.localErr_MsgForInternalError(err));
        }
      })
    );
  }

  // ============= local errors ================

  private localErr_MsgForInternalError(erErvent: any) {
    const tmessage = `
            message:  ${erErvent.message}<br />
            filename :  ${erErvent.filename}
            `;
    return this._toast.error(tmessage, {
      dismissible: true,
      duration: 5000,
      className: 'hot-toastx',
    });
  }
  // gestione errori
  private handleErrors(err: HttpErrorResponse): Observable<any> {
    switch (err.status) {
      case 400: {
        return of(this.parseApiKnowError(err));
        //   console.error('\n-----------400 NotFound-------------\n' + JSON.stringify(err.url, null, 4));
        break;
      }

      case 401: {
        if (this.accessToken) {
          return of(this.serverErr_401NotAuthorizedError(err));
        }
        //  console.error('\n-----------401 Unauthorized-------------\n' + JSON.stringify(err.message, null, 4));
        break;
      }
      case 403: {
        return of(this._router.navigate(['/auth/logout']));
        //  return of(this.serverErr_401NotAuthorizedError(err));
        // console.error('\n-----------403 Forbidden -------------\n' + JSON.stringify(err.message, null, 4));
        break;
      }
      case 404: {
        return of(this.serverErr_404NotFoundError(err));
        //  console.error('\n----------- 404 Bad Request -------------\n' + JSON.stringify(err.url, null, 4));
        break;
      }

      case 500: {
        return of(this.serverErr_UnknowError(err));
        // console.error('\n----------- 500 Status500InternalServerError -------------\n' + JSON.stringify(err.url, null, 4));
        break;
      }
      // precondition falied
      case 412: {
        return of(this.serverErr_PreconditionFailed(err));
        // console.error('\n----------- 500 Status500InternalServerError -------------\n' + JSON.stringify(err.url, null, 4));
        break;
      }
      default: {
        // tslint:disable-next-line: triple-equals
        if (err.status <= 0) {
          // non è connesso al server !!!
          // TODO https://stackoverflow.com/questions/54750157/how-to-handle-connection-loss-page-in-angular-7
          const back = encodeURI(window.location.href);
          return of(this._router.navigate(['/err/0', back]));
        } else {
          return of(this.serverErr_UnknowError(err));
          //console.error('\n----------- Error server (default) ---------\n' + err.message);
        }
        break;
      }
    }
  }

  // ============= errors ================

  // ============= server errors ================

  private parseApiKnowError(err: any) {
    const custom_message: IApiErrorReturnHeaders = Object.assign(err.error.message);
    if (custom_message && custom_message.message != null) {
      //    .log('-err.error >' + JSON.stringify(err.error, null, 4));

      try {
        return this.serverErr_ShowIApiError(custom_message, err.status);
      } catch (e) {
        return this.serverErr_UnknowError(err);
      }
    } else {
      return this.serverErr_UnknowError(err);
    }
  }

  private serverErr_ShowIApiError(x: IApiErrorReturnHeaders, status: number = 0) {
    const tmessage = `
        <b> ${x.message}</b><br />
        code:  ${x.code}<br />
        error:  ${x.serverResponse}
       `;
    return this._toast.error(tmessage, {
      autoClose: false,
      dismissible: true,
      className: 'hot-toastx',
    });
  }

  // errore customizable usato per errori gravi
  private serverErr_PreconditionFailed(x: any) {
    console.error('NG.INT.ERR.00 --serverErr_PreconditionFailed ->' + JSON.stringify(x, null, 4));
    const tmessage = `
        <b> ${x.error.message}</b><br />
        code:  ${x.error.code}
       `;
    this._toast.error(tmessage, {
      autoClose: false,
      dismissible: true,
      className: 'hot-toastx',
    });
    // se rrrore licenza expired va a login
    if ('LIC.API.ERR.00' == x.error.code) {
      return of(this._router.navigate(['/auth/init-licenza']));
    }
  }

  private serverErr_UnknowError(err: any) {
    /*        error?: any;
                headers?: HttpHeaders;
                status?: number;
                statusText?: string;
                url?: string;
            }); */
    const tmessage = `
        <b> ${err.message}</b><br />
        error:  ${err.error}<br />
        status :  ${err.status}<br />
        statusText :  ${err.statusText}<br />
        url:  ${err.url}
         `;
    return this._toast.error(tmessage, {
      autoClose: false,
      dismissible: true,
      className: 'hot-toastx',
    });
  }
  private serverErr_404NotFoundError(err: any) {
    const tmessage = `
    <b>Page not found</b><br />
        statusCode:  ${err.status}<br />
        statusText :  ${err.statusText}<br />
        url:  ${err.url}<br />
         `;
    return this._toast.error(tmessage, {
      dismissible: true,
      duration: 5000,
      className: 'hot-toastx',
    });
  }
  private serverErr_401NotAuthorizedError(err: any) {
    const tmessage = `
    <b>Not Authorized to view this page </b><br />
        statusCode:  ${err.status}<br />
        statusText :  ${err.statusText}<br />
         `;
    return this._toast.error(tmessage, {
      dismissible: true,
      duration: 5000,
      className: 'hot-toastx',
    });
  }
}

/*
    private messageFor502(err: HttpErrorResponse) {

        const tmessage = `<b> il collegamento al server è stato interrotto</b><br />
               verifica che il pc sia connesso alla rete e il server sia online
             `;
        return this._toastr.warning(tmessage, 'Errore Server:' + err.status, {
            timeOut: 0,
            extendedTimeOut: 0,
            enableHtml: true
        });
    }
    private messageFor408(err: HttpErrorResponse) {

        const tmessage = `<b> Il server non ha risposto in tempo utile </b><br />
                  verifica che il pc sia connesso alla rete e il server sia online
                `;
        return this._toastr.warning(tmessage, 'Errore Server:' + err.status, {
            timeOut: 0,
            extendedTimeOut: 0,
            enableHtml: true
        });
    }
    private messageFor412() {

        const tmessage = `<b> Non è possibile effettuare la richiesta. </b><br />
        <b> L'utente ha perso la connessione al server ... </b><br />
        Cancella la memorizzazione cache del browser con i tasti: Control+ Shift + Canc.
               Poi esci dal portale e fai nuovamente il login.
                `;
        return this._toastr.info(tmessage, 'LOGIN?', {
            timeOut: 0,
            extendedTimeOut: 0,
            enableHtml: true
        });
    }*/
